// extracted by mini-css-extract-plugin
export var root = "_5388a6c0dec7ad10ad3712d227cdd6c9-css";
export var children = "acc5e6e8e15ddbfb10bf8bee93238d3f-css";